import styled from 'styled-components';
import tw from 'twin.macro';
import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export const MovieDetailSlideStyled = styled.div`
  ${tw`mr-5 bg-black min-h-screen flex w-full bg-cover bg-no-repeat bg-center justify-center items-end`};

  &:after {
    ${tw`bg-gradient-to-t from-black z-0`};
    ${tw`block absolute w-full bottom-0`};
    content: '';
    height: 60vh;
  }
`;

export const MovieDetailContentBlockStyled = styled.div`
  ${tw`flex mx-auto z-10 w-full justify-between p-5 lg:pb-10 lg:px-5 md:pb-0`}

  .content-container {
    ${tw`flex w-full justify-between py-5 overflow-hidden mx-auto`}
    max-width: 1360px;

    @media (min-width: ${fullConfig.theme.screens['2xl']}) {
      ${tw`px-8`}
    }
  }

  .movie-poster {
    ${tw`hidden lg:flex relative z-20`}
    max-width: 224px;
    min-height: 410px;
    /* height: 360px; */

    @media (min-width: ${fullConfig.theme.screens['2xl']}) {
      ${tw`md:max-w-xs`}
      width: 306px;
      height: 459px;
    }

    > a > div {
      /* left: 32px !important; */
    }
  }

  img {
    ${tw`max-w-full pl-8`};
  }

  .movie-details {
    ${tw`flex-auto pt-6 z-0 flex-col flex justify-end px-6`};

    h2 {
      ${tw`text-white text-3xl lg:text-5xl font-bold pb-2 w-full`};
    }

    p {
      ${tw`text-base text-white font-normal mb-3`};
      max-width: 700px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
    }

    ul {
      ${tw`flex mt-3`};
      li {
        ${tw`text-base text-white text-sm text-gray-200 font-normal mb-3 pr-3 flex items-center`};

        &:before {
          ${tw` bg-gray-200 rounded-full h-1 w-1 mr-3`};
          content: '';
        }

        &:first-child {
          &:before {
            display: none;
          }
        }
      }
    }
  }
`;

export const CinemaDetailContentStyled = styled.div`
  ${tw`hidden md:flex mx-auto z-10 w-full justify-between py-4 bg-gray-900 relative mb-12  mt-6`};
  max-width: 1360px;
  min-height: 80px;

  p.bold {
    ${tw`text-sm text-white font-bold mb-1`};
    margin-bottom: 6px !important;
  }

  .cinema-detail-outer-wrapper {
    ${tw`flex flex-row justify-between`}
    width: 100%;
    max-width: 700px;
  }

  ul {
    ${tw`flex mt-2`};
    margin-top: 6px !important;

    li {
      ${tw`text-base text-white text-xs text-white font-normal pr-3 flex items-center `};
      color: white !important;
      margin-bottom: 0 !important;

      &:before {
        ${tw`bg-white rounded-full h-1 w-1 mr-3`};
        content: '';
        background: white !important;
      }

      &:first-child {
        &:before {
          display: none;
        }
      }
    }
  }

  a {
    ${tw`text-base font-normal`};
    ${tw`text-primary-500 px-4 pt-2 pb-2 mx-2 border border-primary-500`};
    ${tw`transition transition-all ease-in-out duration-200 rounded-md`};
    ${tw`hover:bg-primary-500 hover:text-black`};
  }

  &:before {
    ${tw`bg-gray-900 absolute z-0 w-full h-full top-0`};
    right: 100%;
    content: '';
  }
`;

export const ComingSoonTextStyled = styled.div`
  ${tw`flex rounded-full py-1 px-4 mr-2 mb-2 whitespace-nowrap text-xs capitalize`};
  ${tw`text-black bg-primary-500 `};
  font-size: 12px;
`;
